export default __webpack_public_path__ + "static/17_29-54db50f042723e3ceb029d2308345b4a.png";